import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';

export const useDealerDiscountSlideOut = () => {
    const sellingPrice = useSelector(offerSelectors.getSellingPrice);
    const [slideOut, setSlideOut] = useState(false);

    const toggleSlideOut = useCallback(() => {
        setSlideOut(!slideOut);
    }, [slideOut]);

    return { fieldKey: JSON.stringify({ sellingPrice }), isSlideOutOpen: slideOut, toggleSlideOut };
};
